import { UseHasPermission } from "#hooks/useHasPermission"
import { UseContextPromotionColaborador } from "#promotions/contexts/ContextPromotionColaborador"
import Button from "@mui/material/Button"
import CardActions from "@mui/material/CardActions"
import Stack from "@mui/material/Stack"
import { useSelector } from "react-redux"
import { usePromotionsContext } from "../../PromotionContext"
import { STATUS } from "#promotions/utils/constants"

export const PromotionColaboradorButtons = ({ disable, detail }) => {
	const { setOpenConfirm, setResponse, setPromotionDetail, is_enabled, promotion } =
		usePromotionsContext()
	const { setOpenVacante, setOpenFiles } = UseContextPromotionColaborador()
	const authorization = useSelector((state) => state.user.colaborador.id)
	const isRH = UseHasPermission("RH")

	let openResponse = (response) => {
		setOpenConfirm(true)
		setResponse(response)
		setPromotionDetail(detail)
	}
	const viewButtonApprove = detail.authorization === authorization || isRH

	let buttons = []

	if (
		detail.authorized == null &&
		is_enabled &&
		promotion.status_id !== STATUS.En_Proceso
	)
		buttons = [
			<Button
				size="small"
				onClick={() => {
					openResponse(true)
				}}
				hidden={false}
			>
				Aprobar
			</Button>,
			<Button
				onClick={() => {
					openResponse(false)
				}}
				size="small"
				hidden={!viewButtonApprove}
			>
				Rechazar
			</Button>,
		]
	else if (detail.authorized === true) {
		buttons = [
			<Button
				onClick={() => {
					setOpenFiles(true)
				}}
				size="small"
			>
				Archivos
			</Button>,
		]
		if (detail.vacante == null && is_enabled)
			buttons.push(
				<Button
					onClick={() => {
						setOpenVacante(true)
					}}
					size="small"
				>
					Crear Vacante
				</Button>,
			)
	}

	return (
		<CardActions>
			<Stack direction={{ xs: "column", md: "column" }} spacing={1}>
				{buttons}
			</Stack>
		</CardActions>
	)
}
